import React from "react";
import { Card, Space, Typography } from "antd";
import CurrencyElement from "@appComponents/CurrencyElement/CurrencyElement";
import { classNames } from "@features/utils/reactFunctions";

import * as style from "./StatsItemStyle.module.scss";

type Props = {
  title: React.ReactNode;
  action: React.ReactNode;
  fieldName: string;
  className?: string;
  currency?: boolean;
  data: Array<{
    title?: string;
    amount: string;
    amountUsd?: string;
    currency?: string;
    upperCase?: boolean;
  }>;
};

const StatsItem = ({ title, data, action, fieldName, className }: Props) => (
  <Card className={classNames(style.card, style[fieldName], className)}>
    {title}
    <div className={style.cardContentWrapper}>
      <div className={style.cardContent}>
        {data.map(
          ({ amount, amountUsd, title, currency = "eth", upperCase }) => (
            <Space
              data-cy={`${title ?? fieldName}-value`}
              direction="vertical"
              size={0}
            >
              <Typography.Title
                style={{ textTransform: "uppercase", marginTop: 15 }}
                level={5}
              >
                {title}
              </Typography.Title>
              <Typography.Text className={style.cardBalance}>
                {currency ? (
                  <CurrencyElement
                    currency={currency}
                    value={amount}
                    upperCase={upperCase}
                  />
                ) : (
                  <span>{amount}</span>
                )}
              </Typography.Text>
              {amountUsd && (
                <Typography.Paragraph className={style.cardBalanceUsd}>
                  <span>≈</span>
                  <CurrencyElement
                    currency="usd"
                    fixedTo={2}
                    value={amountUsd}
                  />
                </Typography.Paragraph>
              )}
            </Space>
          )
        )}
      </div>
      {action}
    </div>
  </Card>
);

export default StatsItem;
